import { THarvestBatch } from './isHarvestBatch';

function harvestBatchVariety<TGenericHarvest>(
	harvest: TGenericHarvest & Pick<THarvestBatch, 'variety'>
): string {
	return harvest.variety;
}

export default harvestBatchVariety;
